import type { ReactElement } from 'react'
import type { OptionProps } from 'react-select'

import Rating from '../../Rating'

import { MAX_RATING_VALUE } from '~/const'

export const formatOptionLabel = ({ label, value }: IOption): ReactElement => {
  return +value === -1 ? <span>{label}</span> : <Rating maxValue={MAX_RATING_VALUE} value={+value} />
}

const CustomRatingOption = ({
  className,
  cx,
  data,
  innerProps,
  innerRef,
  isDisabled,
  isFocused,
  isSelected,
}: OptionProps): ReactElement => {
  const { label, value } = data as IOption

  return (
    <div
      className={cx(
        {
          option: true,
          'option--is-disabled': isDisabled,
          'option--is-focused': isFocused,
          'option--is-selected': isSelected,
        },
        className
      )}
      ref={innerRef}
      {...innerProps}
    >
      {+value === -1 ? <span>{label}</span> : <Rating maxValue={MAX_RATING_VALUE} value={+value} />}
    </div>
  )
}

export default CustomRatingOption
